import { render, staticRenderFns } from "./CourseContentSection.vue?vue&type=template&id=789e892d&scoped=true&"
import script from "./CourseContentSection.vue?vue&type=script&lang=js&"
export * from "./CourseContentSection.vue?vue&type=script&lang=js&"
import style0 from "./CourseContentSection.vue?vue&type=style&index=0&id=789e892d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789e892d",
  null
  
)

export default component.exports